import React from 'react';
import './Logo.css'
import LogoImg from '../../Assets/Logo.svg'

const Logo = () => {
    return ( 
        <img className='Logo' src={LogoImg} alt="" />
     );
}
 
export default Logo;